import React from 'react';
import PropTypes from 'prop-types';
import { Button, ChevronLeftOutlinedIcon, ChevronRightOutlinedIcon } from 'tuui';
import { FormButtons } from 'modules/campaigns/components/Form';
import { useIsCreativeLibrary } from 'modules/campaigns/hooks/useIsCreativeLibrary';
import { GTM_EVENTS } from 'modules/taboola-common-frontend-modules/gtmTracker';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import styles from './campaignCreatorFormButtons.module.scss';

const CampaignCreatorFormButtons = ({
    onBack,
    onCancel,
    onSubmit,
    onSubmitAndAddCreatives,
    disableSubmit,
    onSubmitAndAssignCreatives,
}) => {
    const { isCreativeLibraryEnabled } = useIsCreativeLibrary();

    return (
        <div className={styles['buttons-wrapper']}>
            <FormButtons
                className={styles['form-buttons']}
                onSubmit={onSubmit}
                onBack={onBack}
                disableSubmit={disableSubmit}
                submitLabel={<FormattedMessage id="campaign.creator.submit.button" defaultMessage="Create campaign" />}
                backLabel={<FormattedMessage id="app.actionButtons.back" />}
                backIcon={<ChevronLeftOutlinedIcon />}
                cancelLabel={<FormattedMessage id="app.actionButtons.cancel" />}
                onCancel={onCancel}
                submitButtonType="submit"
                outlineSubmitButton
                showFooterValidations
            />

            {isCreativeLibraryEnabled ? (
                <Button
                    className={styles['add-creatives-button']}
                    onClick={onSubmitAndAssignCreatives}
                    size={Button.variant.md}
                    variant={Button.variant.primary}
                    type="submit"
                >
                    <FormattedMessage
                        id="assign.creatives.create.and.assign.creatives"
                        defaultMessage="Create & assign creatives"
                    />
                    <ChevronRightOutlinedIcon />
                </Button>
            ) : (
                <Button
                    className={styles['add-creatives-button']}
                    onClick={onSubmitAndAddCreatives}
                    size={Button.variant.md}
                    variant={Button.variant.primary}
                    disabled={disableSubmit}
                    data-metrics-event-name={GTM_EVENTS.USABILITY}
                    data-metrics-component="SubmitAndAddCreativesButton"
                    type="submit"
                >
                    <FormattedMessage
                        id="campaign.creator.submit.and.add.creatives.button"
                        defaultMessage="Create & add ads"
                    />
                    <ChevronRightOutlinedIcon />
                </Button>
            )}
        </div>
    );
};

CampaignCreatorFormButtons.propTypes = {
    onBack: PropTypes.func,
    onCancel: PropTypes.func,
    onSubmit: PropTypes.func,
    onSubmitAndAddCreatives: PropTypes.func,
    disableSubmit: PropTypes.bool,
    onSubmitAndAssignCreatives: PropTypes.func,
};

export default CampaignCreatorFormButtons;
